const dateOptions = {
  month: '2-digit',
  day: '2-digit',
  year: '2-digit',
}
const timeOptions = {
  hour: '2-digit',
  minute: '2-digit',
}
const dateTimeOptions = {
  ...dateOptions,
  ...timeOptions,
}

function isValidDate(date: Date): boolean {
  return date instanceof Date && !isNaN(date.getTime())
}

export function formatDate(dateString: string): string {
  const date = new Date(dateString)
  if (!dateString || !isValidDate(date)) {
    throw Error('Invalid date format.')
  }
  return date.toLocaleString('en-US', dateOptions)
}

export function formatDateTime(dateString: string): string {
  const date = new Date(dateString)
  if (!dateString || !isValidDate(date)) {
    throw Error('Invalid date format.')
  }
  return date.toLocaleString('en-US', dateTimeOptions)
}
